import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "zero-state" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "zero-state__title" }, "No Data", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_svg_icon, {
      class: "icon--extra-large icon--width",
      src: `icons/no-data.svg`
    }, null, 8, ["src"]),
    _hoisted_2
  ]))
}